import { format, subDays } from 'date-fns';

export type ReportDateRangeYmd = {
  startDate: string;
  endDate: string;
};

/** `YYYY-MM-DD` in local calendar. */
export function toYyyyMmDd(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}

/** Today only (local calendar): same start and end date. */
export function getTodayCalendarRange(now = new Date()): ReportDateRangeYmd {
  const ymd = toYyyyMmDd(now);
  return { startDate: ymd, endDate: ymd };
}

/** Rolling 7 calendar days ending today (inclusive). */
export function getLast7DaysInclusiveRange(now = new Date()): ReportDateRangeYmd {
  return {
    startDate: toYyyyMmDd(subDays(now, 6)),
    endDate: toYyyyMmDd(now),
  };
}

/** Rolling 30 calendar days ending today (inclusive): today and the 29 prior days. */
export function getLast30DaysInclusiveRange(now = new Date()): ReportDateRangeYmd {
  return {
    startDate: toYyyyMmDd(subDays(now, 29)),
    endDate: toYyyyMmDd(now),
  };
}

/** Rolling 365 calendar days ending today (inclusive): today and the 364 prior days. */
export function getLast365DaysInclusiveRange(now = new Date()): ReportDateRangeYmd {
  return {
    startDate: toYyyyMmDd(subDays(now, 364)),
    endDate: toYyyyMmDd(now),
  };
}
